import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

async function renderApp() {
  await msalInstance.initialize();

  // After initialize(), MSAL has loaded the token cache from localStorage but
  // the active account is in-memory only — it is NOT persisted across tabs or
  // page reloads. Promote the first cached account to active so that
  // getActiveAccount() is never null in a fresh tab that has a valid session.
  // This prevents the axios interceptor from missing the auth header on the
  // very first API call (e.g. menuService.getRoutes()), which would otherwise
  // trigger a 401 → clearCache → redirect to login → lose the deep-link URL.
  if (!msalInstance.getActiveAccount()) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  }

renderApp();
